// FaqPage.js
import React, { useState } from 'react';
import ConferenceNav from './ConferenceNav';
import NewFooter from './NewFooter';
import SEO from './SEO';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Which is the best thesis writing service in Bhopal?',
      answer:
        'Assurance Education Group (ResearchLens / aegresearch) is a leading thesis writing service in Bhopal, offering end-to-end support from topic selection and research methodology to writing, editing, plagiarism checks and viva preparation. Call +91 6268558700 to discuss your requirements.',
    },
    {
      question: 'Do you help with paper writing and SCI research paper preparation?',
      answer:
        'Yes. We provide complete paper writing support including manuscript drafting, formatting to journal guidelines, technical editing and preparation of SCI research papers for submission to reputed indexed journals.',
    },
    {
      question: 'Can you assist with research paper publication in SCI and Scopus journals?',
      answer:
        'We guide authors through the full research paper publication process - journal selection, manuscript preparation, submission, responding to reviewer comments and revisions - for SCI paper publication and Scopus paper publication.',
    },
    {
      question: 'How long does thesis writing and paper publication take?',
      answer:
        'A thesis typically takes 4 to 12 weeks depending on scope and revisions. SCI and Scopus paper publication timelines depend on the target journal, usually ranging from a few weeks to several months for peer review.',
    },
    {
      question: 'What is the AIC-RAETHM 2025 Conference?',
      answer:
        'The AIC-RAETHM 2025 Conference is an annual event that brings together researchers, scholars, and industry professionals to discuss advancements in engineering technology, healthcare, and management.',
    },
    // {
    //   "question": "How can I register for the AIC-RAETHM 2025 Conference?",
    //   "answer": "You can register for the conference by visiting our registration page and filling out the required information."
    // },
    {
      question: 'What are the conference dates?',
      answer: 'The conference will be held on January 10th and 11th, 2025.',
    },
    {
      question: 'Where will the conference be held?',
      answer:
        'The AIC-RAETHM 2025 Conference will be organized by Vidhyapeeth Institute of Science and Technology, located near New SOS Balgram, Sahara By Pass, Raisen Road, Bhopal, MP, India.',
    },
    {
      question: 'Is there a fee to attend the conference?',
      answer:
        'Yes, there is a registration fee. Please check our website for detailed pricing information.',
    },
    {
      question: 'Will there be any workshops?',
      answer:
        'Yes, we will have several workshops covering various topics related to engineering technology, healthcare, and management. You can find more information on our workshops page.',
    },
    {
      question: 'How can I contact the organizers?',
      answer:
        'You can contact us through the contact form on our website, by emailing aeggrouphelpdesk@gmail.com, or by calling +91 6268558700.',
    },
  ];

  const toggleAnswer = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SEO
        title="Thesis Writing & Paper Publication FAQ Bhopal | AEG Group"
        description="Frequently asked questions about best thesis writing services in bhopal, Plagiarism Check Bhopal, Mtech Thesis Writing, PhD Thesis writing service and help."
        canonicalPath="/faq"
        keywords={[
          "best thesis writing services in bhopal",
          "Plagiarism Check Bhopal",
          "Mtech Thesis Writing",
          "PhD Thesis writing service and help",
          "SCI paper writing bhopal",
          "Paper Writing Bhopal"
        ]}
        schemaData={faqSchema}
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'FAQ', path: '/faq' }
        ]}
      />
      <ConferenceNav />
      <div className='min-h-screen bg-gray-100 flex flex-col items-center justify-center pt-28 pb-8 px-6'>
      <h1 className='text-4xl font-bold text-center mb-8'>
        Frequently Asked Questions
      </h1>
      <div className='w-full max-w-2xl'>
        {faqs.map((faq, index) => (
          <div key={index} className='bg-white rounded-lg shadow-md mb-4'>
            <button
              className='w-full text-left p-4 focus:outline-none bg-gray-200 hover:bg-gray-300 transition duration-200'
              onClick={() => toggleAnswer(index)}
            >
              <h2 className='text-lg font-semibold'>{faq.question}</h2>
            </button>
            {openIndex === index && (
              <div className='p-4 border-t border-gray-300'>
                <p className='text-gray-700'>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
    <div className='w-screen'>
      <NewFooter />
    </div>
  </>
  );
};

export default Faq;
